<div class="text-center not-found">
  <div class="wrapper">
    <img class="logo" src="assets/images/logo.png" />
    <div>
      <h2>404 Not Found</h2>
      <p>
        The page you are looking for could not be found
      </p>
    </div>
  </div>
</div>